import { PUBLIC_BUTANE_API_BASE_URL } from '$env/static/public'

export interface ProtocolSummary {
  activeCdps: number
  allTimeCdps: number
  totalDebt: string | null
  totalValueLocked: string | null
}

function isProtocolSummary(value: unknown): value is ProtocolSummary {
  if (!value || typeof value !== 'object') return false

  const summary = value as Record<string, unknown>
  return (
    typeof summary.activeCdps === 'number' &&
    typeof summary.allTimeCdps === 'number' &&
    (typeof summary.totalDebt === 'string' || summary.totalDebt === null) &&
    (typeof summary.totalValueLocked === 'string' || summary.totalValueLocked === null)
  )
}

export async function getProtocolSummary(): Promise<ProtocolSummary> {
  const apiBaseUrl = PUBLIC_BUTANE_API_BASE_URL
  if (!apiBaseUrl) throw new Error('PUBLIC_BUTANE_API_BASE_URL environment variable is required')

  const response = await fetch(`${apiBaseUrl.replace(/\/$/, '')}/stats`)
  if (!response.ok) throw new Error(`GET /stats failed with status ${response.status}`)

  const summary: unknown = await response.json()
  if (!isProtocolSummary(summary)) throw new Error('GET /stats returned an invalid response')

  return summary
}
